import React, { useCallback, useEffect, useState } from "react";
import { Calendar } from "lucide-react";
import { setConsultSource } from "../lib/consultSource";

const SCROLL_THRESHOLD_PX = 700;

export default function StickyConsultButton() {
  const [show, setShow] = useState(false);
  const [nearContact, setNearContact] = useState(false);

  const onScroll = useCallback(() => {
    const y = window.scrollY;
    setShow(y > SCROLL_THRESHOLD_PX);
    const contact = document.getElementById("contact");
    if (contact) {
      const rect = contact.getBoundingClientRect();
      setNearContact(rect.top < window.innerHeight && rect.bottom > 0);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [onScroll]);

  if (!show || nearContact) return null;

  return (
    <a
      href="#contact"
      onClick={() => setConsultSource("Floating “Schedule a Consultation” button")}
      className="fixed bottom-6 right-6 z-40 group bg-[#b8924a] hover:bg-[#a07f3e] text-white shadow-2xl border border-[#b8924a] flex items-center gap-3 pl-4 pr-5 py-3 transition-all duration-300"
      aria-label="Schedule a Consultation"
      data-testid="sticky-consult-button"
    >
      <Calendar className="w-5 h-5" />
      <span className="font-serif text-base tracking-wide whitespace-nowrap">Schedule a Consultation</span>
    </a>
  );
}
